type CookieType = {
  isAgreed: boolean;
  date: string;
};

const SHARED_COOKIE_DOMAIN = 'romanticai.com';

const getSharedCookieDomain = () => {
  const { hostname } = window.location;
  if (hostname === SHARED_COOKIE_DOMAIN || hostname.endsWith(`.${SHARED_COOKIE_DOMAIN}`)) {
    return `.${SHARED_COOKIE_DOMAIN}`;
  }
  return undefined;
};

export const updateCookie = (key: string, isAgreed = true) => {
  const options: Record<string, string | number | boolean | undefined> = {
    path: '/',
    samesite: 'lax',
    secure: window.location.protocol === 'https:',
    'max-age': 60 * 60 * 24 * 365,
    domain: getSharedCookieDomain(),
  };

  const value: CookieType = {
    isAgreed,
    date: new Date().toISOString(),
  };

  const valueEn = encodeURIComponent(JSON.stringify(value));
  let updatedCookie = `${key}=${valueEn}`;
  for (const propName in options) {
    const propValue = options[propName];
    if (propValue === undefined || propValue === false) {
      continue;
    }
    updatedCookie += `; ${propName}`;
    if (propValue !== true) {
      updatedCookie += `=${propValue}`;
    }
  }
  document.cookie = updatedCookie;
};

export const getCookie = (key: string): CookieType | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${key}=`);
  if (parts.length === 2) {
    const data = parts.pop()?.split(';').shift();
    if (data) {
      try {
        return JSON.parse(decodeURIComponent(data));
      } catch {
        return null;
      }
    }
  }
  return null;
};

export const checkIsAgreed = (key: string) => {
  const data = getCookie(key);
  if (data) {
    return data.isAgreed;
  }
  return false;
};
